<div>
  <div class="work-shift__tickets-list">
    <div class="tickets-list__wrapper">
      <div class="wrapper__header" #wrapperHeader>
        <div class="tickets-list__header" #ticketsListHeader>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--interval">Интервал</div>
          <div class="tickets-list__item_th tickets-list__item">Район / Адрес</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--scale-priority tickets-list__item_th_b">Маштаб/Приоритет</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--description">Описание ГП</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--assign">Назначенные выезды</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--number">Номер</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--status-vk">Статус BK</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--status-hd">Статус HD</div>
        </div>
      </div>
    </div>
    <div class="tickets-list__content pos-r" #ticketsList [style.height.px]="listHeight">
      <div class="padding-24" *ngIf="tickets.ticketsLoading">
        <app-loader></app-loader>
      </div>
      <ng-container *ngIf="!tickets.ticketsLoading">
        <div class="tickets-list__content-wrapper" >
          <ng-container *ngFor="let appliedTypeGP of appliedTypeGPs">
            <div class="date__wrapper" *ngIf="hasTickets(tickets.dataTable, appliedTypeGP, appliedSubtypeGPs)">
              <div class="date padding-8 bg-blue-light">
                <span class="title title--s">
                  {{ appliedTypeGP.name }}
                </span>
              </div>
            </div>
            <ng-container
              *ngTemplateOutlet="
                ticketList;
                context: {
                  filterBy: filterBy(appliedTypeGP, appliedSubtypeGPs)
                }
              "
            >
            </ng-container>

            <ng-template #ticketList let-filterBy="filterBy">
              <!--                список дат-->
              <ng-container *ngIf="tickets.dataTable && tickets.dataTable.length">
                <div *ngFor="let date of tickets.dataTable">
                  <ng-container *ngIf="date.isShow">
                    <!--                            edo tickets-->
                    <div *ngFor="let interval of date.edo_intervals" class="content__address-intervals mt-2 mb-2">
                      <ng-container *ngIf="interval.isShow">
                        <div *ngFor="let district of interval.districts; let index = index" class="address-intervals__districts">
                          <div class="date__wrapper" *ngIf="filterBy(district.tickets).length">
                            <div class="date padding-8 bg-blue-light">
                              <span class="title title--s">
                                <span *ngIf="date.date === currentDate">Сегодня</span>
                                <span *ngIf="date.date !== currentDate">
                                  {{ date.date | dateFormat: 'DD MMM YYYYг.' }}
                                </span>
                              </span>
                            </div>
                          </div>
                          <ng-container *ngIf="district.isShow">
                            <ng-container *ngIf="index === 0">
                              <div *ngIf="filterBy(district.tickets).length" class="address-intervals__action">
                                <div class="tickets-list__item tickets-list__item--interval">
                                  <div class="grid grid--gap-4">
                                    <div class="grid__box grid__box--size-min">
                                      <div class="grid" (click)="interval.isOpen = !interval.isOpen">
                                        <div class="grid__box grid__box--size-min" *ngIf="interval.isOpen">
                                          <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                        </div>
                                        <div class="grid__box grid__box--size-min" *ngIf="!interval.isOpen">
                                          <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      <div class="ml-8">
                                        <app-icon [glyph]="'doc'" [size]="'16'" [color]="'gray-dark'"></app-icon>
                                      </div>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ interval.ticketsCount }}
                                    </div>
                                  </div>
                                </div>
                                <div class="tickets-list__item">
                                  <div *ngIf="interval.isOpen" class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                                    <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                      <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                      <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ district.district_name }}
                                      (<span
                                        [ngClass]="{
                                          'color-green-dark': district.assigned === district.all
                                        }"
                                        >{{ district.assigned }}
                                        /
                                        {{ district.all }}</span
                                      >)
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ng-container *ngIf="district.isOpened && interval.isOpen">
                                <div class="address-intervals__ticket" *ngFor="let ticket of filterBy(district.tickets)">
                                  <ng-container *ngIf="ticket.isShow">
                                    <div class="tickets-list__item tickets-list__item--interval"></div>
                                    <div class="tickets-list__item tickets-list__item-address">
                                      <div class="grid grid--gap-4">
                                        <div class="grid__box grid__box--size-2">
                                          <app-ticket-checker
                                            [ticket]="ticket"
                                            [ticketsMultipleAssign]="ticketsMultipleAssign"
                                            [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          ></app-ticket-checker>
                                        </div>
                                        <div class="grid__box grid__box--size-9">
                                          {{ ticket.hd_address }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--scale-priority">
                                      <app-tickets-priority-scale [ticket]="ticket"> </app-tickets-priority-scale>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--description">
                                      <app-tickets-description [ticket]="ticket"> </app-tickets-description>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--row">
                                      <span class="tickets-list__item-brigade">
                                        <div *ngFor="let departure of ticket.departures"
                                          class="item-brigade"
                                          [ngClass]="{
                                            'pr-8': departure
                                          }"
                                        >
                                          <app-brigade-popover [brigade]="departure">
                                          </app-brigade-popover>
                                        </div>
                                        <div
                                          class="item-brigade-assign"
                                          [ngClass]="{
                                            'item-brigade-assign--not-brigade': !ticket.brigade || (isOpenTicketsBrigadeAssignPopover && ticketBrigadePopoverOpen.id === ticket.id)
                                          }"
                                        >
                                          <app-tickets-brigade-assign
                                            [ticket]="ticket"
                                            [filter]="filter"
                                            [ticketsCurrentFilter]="ticketsCurrentFilter"
                                            [brigadeAssign]="brigadeAssign"
                                            [ticketsMultipleAssign]="ticketsMultipleAssign"
                                            (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                          ></app-tickets-brigade-assign>
                                        </div>
                                      </span>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--number">
                                      <a
                                        class="link {{ 'link--' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}"
                                        [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]"
                                      >
                                        {{ ticket.hd_ticket_number }}
                                      </a>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-vk">
                                      <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                        {{ ticket.ticket_status && ticket.ticket_status.name }}
                                      </span>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-hd">
                                      {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="index > 0 && interval.isOpen">
                              <div class="address-intervals__action">
                                <div class="tickets-list__item tickets-list__item--interval tickets-list__item--not-hover"></div>
                                <div class="tickets-list__item">
                                  <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                                    <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                      <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                      <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ district.district_name }}
                                      (
                                      <span
                                        [ngClass]="{
                                          'color-green-dark': district.assigned === district.all
                                        }"
                                        >{{ district.assigned }}
                                        /
                                        {{ district.all }}</span
                                      >
                                      )
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ng-container *ngIf="district.isOpened">
                                <div class="address-intervals__ticket" *ngFor="let ticket of filterBy(district.tickets)">
                                  <ng-container *ngIf="ticket.isShow">
                                    <div class="tickets-list__item tickets-list__item--interval">
                                      <div class="item--interval-date--hover"></div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item-address">
                                      <div class="grid grid--gap-4">
                                        <div class="grid__box grid__box--size-2">
                                          <app-ticket-checker
                                            [ticket]="ticket"
                                            [ticketsMultipleAssign]="ticketsMultipleAssign"
                                            [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          ></app-ticket-checker>
                                        </div>
                                        <div class="grid__box grid__box--size-9">
                                          {{ ticket.hd_address }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--scale-priority">
                                      <app-tickets-priority-scale [ticket]="ticket"> </app-tickets-priority-scale>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--description">
                                      <app-tickets-description [ticket]="ticket"> </app-tickets-description>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--row">
                                      <div class="tickets-list__item-brigade">
                                        <div *ngFor="let departure of ticket.departures"
                                             class="item-brigade"
                                             [ngClass]="{
                                            'pr-8': departure
                                          }"
                                        >
                                          <app-brigade-popover [brigade]="departure">
                                          </app-brigade-popover>
                                        </div>
                                      </div>
                                      <app-tickets-brigade-assign
                                        [ticket]="ticket"
                                        [filter]="filter"
                                        [ticketsCurrentFilter]="ticketsCurrentFilter"
                                        [brigadeAssign]="brigadeAssign"
                                        [ticketsMultipleAssign]="ticketsMultipleAssign"
                                        (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                      ></app-tickets-brigade-assign>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--number">
                                      <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]">
                                        {{ ticket.hd_ticket_number }}
                                      </a>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-vk">
                                      <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                        {{ ticket.ticket_status && ticket.ticket_status.name }}
                                      </span>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-hd">
                                      {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                    <!--                            /edo tickets-->
                    <!--                            gp tickets-->
                    <div *ngFor="let interval of date.gp_intervals" class="content__address-intervals mt-2 mb-2">
                      <ng-container *ngIf="interval.isShow">
                        <div *ngFor="let district of interval.districts; let index = index" class="address-intervals__districts">
                          <div class="date__wrapper" *ngIf="filterBy(district.tickets).length">
                            <div class="date padding-8 bg-blue-light">
                              <span class="title title--s">
                                <span *ngIf="date.date === currentDate">Сегодня</span>
                                <span *ngIf="date.date !== currentDate">
                                  {{ date.date | dateFormat: 'DD MMM YYYYг.' }}
                                </span>
                              </span>
                            </div>
                          </div>
                          <ng-container *ngIf="district.isShow">
                            <ng-container *ngIf="index === 0">
                              <div class="address-intervals__action" *ngIf="filterBy(district.tickets).length">
                                <div class="tickets-list__item tickets-list__item--interval">
                                  <div class="grid grid--gap-4">
                                    <div class="grid__box grid__box--size-min">
                                      <div class="grid" (click)="interval.isOpen = !interval.isOpen">
                                        <div class="grid__box grid__box--size-min" *ngIf="interval.isOpen">
                                          <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                        </div>
                                        <div class="grid__box grid__box--size-min" *ngIf="!interval.isOpen">
                                          <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      <div class="ml-8">
                                        <app-icon [glyph]="'triangle-warning'" [size]="'16'" [color]="'red-dark'"></app-icon>
                                      </div>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ interval.ticketsCount }}
                                    </div>
                                  </div>
                                </div>
                                <div class="tickets-list__item">
                                  <div class="grid grid--gap-8 cur-pointer" *ngIf="interval.isOpen" (click)="changeStateOpened(district)">
                                    <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                      <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                      <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ district.district_name }}
                                      (<span
                                        [ngClass]="{
                                          'color-green-dark': district.assigned === district.all
                                        }"
                                        >{{ district.assigned }}
                                        /
                                        {{ district.all }}</span
                                      >)
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ng-container *ngIf="district.isOpened && interval.isOpen">
                                <div class="address-intervals__ticket" *ngFor="let ticket of filterBy(district.tickets)">
                                  <ng-container *ngIf="ticket.isShow">
                                    <div class="tickets-list__item tickets-list__item--interval">
                                      <div class="item--interval-date--hover">
                                        {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                        -
                                        {{ interval.int_end | dateFormat: 'HH:mm' }}
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item-address">
                                      <div class="grid grid--gap-4">
                                        <div class="grid__box grid__box--size-2">
                                          <app-ticket-checker
                                            [ticket]="ticket"
                                            [ticketsMultipleAssign]="ticketsMultipleAssign"
                                            [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          ></app-ticket-checker>
                                        </div>
                                        <div class="grid__box grid__box--size-9">
                                          {{ ticket.hd_address }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--scale-priority">
                                      <app-tickets-priority-scale [ticket]="ticket"> </app-tickets-priority-scale>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--description">
                                      <app-tickets-description [ticket]="ticket"> </app-tickets-description>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--row">
                                      <span class="tickets-list__item-brigade">
                                        <div *ngFor="let departure of ticket.departures"
                                             class="item-brigade"
                                             [ngClass]="{
                                            'pr-8': departure
                                          }"
                                        >
                                          <app-brigade-popover [brigade]="departure">
                                          </app-brigade-popover>
                                        </div>
                                      </span>
                                      <div
                                        class="item-brigade-assign"
                                        [ngClass]="{
                                            'item-brigade-assign--not-brigade': !ticket.brigade || (isOpenTicketsBrigadeAssignPopover && ticketBrigadePopoverOpen.id === ticket.id)
                                          }"
                                      >
                                        <app-tickets-brigade-assign
                                          [ticket]="ticket"
                                          [filter]="filter"
                                          [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          [brigadeAssign]="brigadeAssign"
                                          [ticketsMultipleAssign]="ticketsMultipleAssign"
                                          (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                        ></app-tickets-brigade-assign>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--number">
                                      <a
                                        class="link {{ 'link--' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}"
                                        [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]"
                                      >
                                        {{ ticket.hd_ticket_number }}
                                      </a>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-vk">
                                      <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                        {{ ticket.ticket_status && ticket.ticket_status.name }}
                                      </span>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-hd">
                                      {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="index > 0 && interval.isOpen">
                              <div class="address-intervals__action">
                                <div class="tickets-list__item tickets-list__item--interval tickets-list__item--not-hover"></div>
                                <div class="tickets-list__item">
                                  <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                                    <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                      <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                      <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ district.district_name }}
                                      (
                                      <span
                                        [ngClass]="{
                                          'color-green-dark': district.assigned === district.all
                                        }"
                                        >{{ district.assigned }}
                                        /
                                        {{ district.all }}</span
                                      >
                                      )
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ng-container *ngIf="district.isOpened">
                                <div class="address-intervals__ticket" *ngFor="let ticket of filterBy(district.tickets)">
                                  <ng-container *ngIf="ticket.isShow">
                                    <div class="tickets-list__item tickets-list__item--interval">
                                      <div class="item--interval-date--hover">
                                        {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                        -
                                        {{ interval.int_end | dateFormat: 'HH:mm' }}
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item-address">
                                      <div class="grid grid--gap-4">
                                        <div class="grid__box grid__box--size-2">
                                          <app-ticket-checker
                                            [ticket]="ticket"
                                            [ticketsMultipleAssign]="ticketsMultipleAssign"
                                            [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          ></app-ticket-checker>
                                        </div>
                                        <div class="grid__box grid__box--size-9">
                                          {{ ticket.hd_address }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--scale-priority">
                                      <app-tickets-priority-scale [ticket]="ticket"> </app-tickets-priority-scale>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--description">
                                      <app-tickets-description [ticket]="ticket"> </app-tickets-description>
                                    </div>
                                    <div class="tickets-list__item">
                                      <div *ngFor="let departure of ticket.departures"
                                           class="item-brigade"
                                           [ngClass]="{
                                            'pr-8': departure
                                          }"
                                      >
                                        <app-brigade-popover [brigade]="departure">
                                        </app-brigade-popover>
                                      </div>
                                      <app-tickets-brigade-assign
                                        [ticket]="ticket"
                                        [filter]="filter"
                                        [ticketsCurrentFilter]="ticketsCurrentFilter"
                                        [brigadeAssign]="brigadeAssign"
                                        [ticketsMultipleAssign]="ticketsMultipleAssign"
                                        (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                      ></app-tickets-brigade-assign>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--number">
                                      <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]">
                                        {{ ticket.hd_ticket_number }}
                                      </a>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-vk">
                                      <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                        {{ ticket.ticket_status && ticket.ticket_status.name }}
                                      </span>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-hd">
                                      {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                    <!--                            /gp tickets-->
                    <!--                            other tickets-->
                    <div *ngFor="let interval of date.intervals" class="content__address-intervals">
                      <ng-container *ngIf="interval.isShow">
                        <div class="address-intervals__districts" *ngFor="let district of interval.districts; let index = index">
                          <div class="date__wrapper" *ngIf="filterBy(district.tickets).length">
                            <div class="date padding-8 bg-blue-light">
                              <span class="title title--s">
                                <span *ngIf="date.date === currentDate">Сегодня</span>
                                <span *ngIf="date.date !== currentDate">
                                  {{ date.date | dateFormat: 'DD MMM YYYYг.' }}
                                </span>
                              </span>
                            </div>
                          </div>
                          <ng-container *ngIf="district.isShow">
                            <ng-container *ngIf="index === 0">
                              <div class="address-intervals__action" *ngIf="filterBy(district.tickets).length">
                                <div class="tickets-list__item tickets-list__item--interval">
                                  <span>
                                    {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                    -
                                    {{ interval.int_end | dateFormat: 'HH:mm' }}
                                  </span>
                                </div>
                                <div class="tickets-list__item">
                                  <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                                    <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                      <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                      <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ district.district_name }}
                                      (<span
                                        [ngClass]="{
                                          'color-green-dark': district.assigned === district.all
                                        }"
                                        >{{ district.assigned }}
                                        /
                                        {{ district.all }}</span
                                      >)
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ng-container *ngIf="district.isOpened">
                                <div class="address-intervals__ticket" *ngFor="let ticket of filterBy(district.tickets)">
                                  <ng-container *ngIf="ticket.isShow">
                                    <div class="tickets-list__item tickets-list__item--interval">
                                      <div class="item--interval-date--hover">
                                        {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                        -
                                        {{ interval.int_end | dateFormat: 'HH:mm' }}
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item-address">
                                      <div class="grid grid--gap-4">
                                        <div class="grid__box grid__box--size-2">
                                          <app-ticket-checker
                                            [ticket]="ticket"
                                            [ticketsMultipleAssign]="ticketsMultipleAssign"
                                            [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          ></app-ticket-checker>
                                        </div>
                                        <div class="grid__box grid__box--size-9">
                                          {{ ticket.hd_address }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--scale-priority">
                                      <app-tickets-priority-scale [ticket]="ticket"> </app-tickets-priority-scale>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--description">
                                      <app-tickets-description [ticket]="ticket"> </app-tickets-description>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--row">
                                      <span class="tickets-list__item-brigade">
                                        <div *ngFor="let departure of ticket.departures"
                                             class="item-brigade"
                                             [ngClass]="{
                                            'pr-8': departure
                                          }"
                                        >
                                          <app-brigade-popover [brigade]="departure">
                                          </app-brigade-popover>
                                        </div>
                                      </span>
                                      <div
                                        class="item-brigade-assign"
                                        [ngClass]="{
                                            'item-brigade-assign--not-brigade': !ticket.brigade || (isOpenTicketsBrigadeAssignPopover && ticketBrigadePopoverOpen.id === ticket.id)
                                          }"
                                      >
                                        <app-tickets-brigade-assign
                                          [ticket]="ticket"
                                          [filter]="filter"
                                          [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          [brigadeAssign]="brigadeAssign"
                                          [ticketsMultipleAssign]="ticketsMultipleAssign"
                                          (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                        ></app-tickets-brigade-assign>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--number">
                                      <a
                                        class="link {{ 'link--' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}"
                                        [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]"
                                      >
                                        {{ ticket.hd_ticket_number }}
                                      </a>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-vk">
                                      <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                        {{ ticket.ticket_status && ticket.ticket_status.name }}
                                      </span>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-hd">
                                      {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="index > 0">
                              <div class="address-intervals__action">
                                <div class="tickets-list__item tickets-list__item--interval tickets-list__item--not-hover"></div>
                                <div class="tickets-list__item">
                                  <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                                    <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                      <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                      <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                    </div>
                                    <div class="grid__box grid__box--size-min">
                                      {{ district.district_name }}
                                      (
                                      <span
                                        [ngClass]="{
                                          'color-green-dark': district.assigned === district.all
                                        }"
                                        >{{ district.assigned }}
                                        /
                                        {{ district.all }}</span
                                      >
                                      )
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <ng-container *ngIf="district.isOpened">
                                <div class="address-intervals__ticket" *ngFor="let ticket of filterBy(district.tickets)">
                                  <ng-container *ngIf="ticket.isShow">
                                    <div class="tickets-list__item tickets-list__item--interval">
                                      <div class="item--interval-date--hover">
                                        {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                        -
                                        {{ interval.int_end | dateFormat: 'HH:mm' }}
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item-address">
                                      <div class="grid grid--gap-4">
                                        <div class="grid__box grid__box--size-2">
                                          <app-ticket-checker
                                            [ticket]="ticket"
                                            [ticketsMultipleAssign]="ticketsMultipleAssign"
                                            [ticketsCurrentFilter]="ticketsCurrentFilter"
                                          ></app-ticket-checker>
                                        </div>
                                        <div class="grid__box grid__box--size-9">
                                          {{ ticket.hd_address }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--scale-priority">
                                      <app-tickets-priority-scale [ticket]="ticket"> </app-tickets-priority-scale>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--description">
                                      <app-tickets-description [ticket]="ticket"> </app-tickets-description>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--row">
                                      <div class="tickets-list__item-brigade">
                                        <div *ngFor="let departure of ticket.departures"
                                             class="item-brigade"
                                             [ngClass]="{
                                            'pr-8': departure
                                          }"
                                        >
                                          <app-brigade-popover [brigade]="departure">
                                          </app-brigade-popover>
                                        </div>
                                      </div>
                                      <app-tickets-brigade-assign
                                        [ticket]="ticket"
                                        [filter]="filter"
                                        [ticketsCurrentFilter]="ticketsCurrentFilter"
                                        [brigadeAssign]="brigadeAssign"
                                        [ticketsMultipleAssign]="ticketsMultipleAssign"
                                        (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                      ></app-tickets-brigade-assign>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--number">
                                      <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]">
                                        {{ ticket.hd_ticket_number }}
                                      </a>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-vk">
                                      <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                        {{ ticket.ticket_status && ticket.ticket_status.name }}
                                      </span>
                                    </div>
                                    <div class="tickets-list__item tickets-list__item--status-hd">
                                      {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                    <!--                            /other tickets-->
                  </ng-container>
                </div>
              </ng-container>
              <!-- список дат-->
            </ng-template>
          </ng-container>
        </div>

        <div *ngIf="showNoData()" class="padding-24 ta-center text-italic color-gray-dark tickets-list__no-data">Заявки по заданным критериям не найдены.</div>
      </ng-container>
    </div>
  </div>
</div>
